import dayjs from 'dayjs'

/**
 * To add proper default values to TextField where type is date, use this format function
 */
export const formatDayjsToStringDateType = (date: dayjs.Dayjs): string =>
  date && dayjs(date).startOf('day').format('YYYY.MM.DD')
